export default __webpack_public_path__ + "static/media/logo.685e06bd.svg";